import * as React from 'react';
import SliderCarusel from "../Invoicing/Slider";
import {connect} from "react-redux";
import {Redirect} from "react-router-dom";
import {
    Form,
    Field,
    Formik} from 'formik'
import {
    getPropertyManagersAction,
    getVendorCategoryAction,
    addCoisDataAction,
    rewriteCoisValuesArrayAction,
    changeCoisValuesArrayAction,
    clearCoisDataStorAction
} from "../../actions";
import {coiCreator,coiValuesCreator} from "./helpers";
import ReactSelect from "./Select";
import Spinner from "../Spinner";
import * as Yup from 'yup';
import {validationSchemaForCoisVeiw} from '../../utils/form/getValidationSchema'
import CoisViewFileds from "./CoisViewFields";

export interface Props {
    coisData: any;
    getPropertyManagersAction: any;
    properties: any;
    pending: any;
    vendorCategorys: any;
    getVendorCategoryAction: any;
    addCoisDataAction: any;
    history: any;
    values: any;
    setValues: any;
    errors: any;
    touched: any;
    changeCoisValuesArrayAction: any;
    coisValues: any;
    rewriteCoisValuesArrayAction: any;
    clearCoisDataStorAction();
}

export interface State {
    currentIndex: any;
    data: any[];
    errors: any;
    disabled: any;
}

class CoisView extends React.Component<Props, State> {
    state = {
        currentIndex: 0,
        data: [],
        errors: {},
        disabled: false,
    };

    componentDidMount() {
        this.props.getPropertyManagersAction();
        this.props.getVendorCategoryAction();
        if (!this.props.pending && this.props.coisData.length === 0) {
            this.props.history.push('/cois');
        }
    };

    setIndex = (isPlus) => {
        const {currentIndex} = this.state;
        this.setState({currentIndex: isPlus ? currentIndex + 1 : currentIndex - 1});
    };

    onHandleSubmit = (values) => {
        // @ts-ignore
        const result = this.props.coisValues;
        const coi = coiCreator(values);
        result.push(coi);
        // @ts-ignore
        const prom = this.props.addCoisDataAction({data: result});
        prom.then(() => {
            window.scrollTo(0, 0);
            if(values.next_invoice){
                this.setIndex(true);
            } else if(values.prev_invoice){
                this.setIndex(false);
            }else{
                this.props.clearCoisDataStorAction();
                this.props.history.push('/cois/');
            }
        })
    };

    render() {
        const {currentIndex, disabled} = this.state;
        const {coisData} = this.props;
        const properties = this.props.properties && this.props.properties.map((property) => {
            return {value: property.property, label: property.property_name}
        });
        const vendorCategorys = this.props.vendorCategorys && this.props.vendorCategorys.map((vendorCategory) => {
            return {value: vendorCategory.id, label: vendorCategory.name}
        });
        if (!this.props.coisData[this.state.currentIndex]) {
            return <Spinner/>;
        }

        const d = coisData[this.state.currentIndex];
        const initValue = coiValuesCreator(d,this.props.properties, this.props.vendorCategorys);

        const err: any = this.state.errors;
        return (!coisData && <Redirect to='/cois/'/>) ||
            (
                <div className="page-content view-invoice">
                    <h1 className="page-title">Invoicing</h1>
                    <Formik
                        {...[this.props]}
                        enableReinitialize
                        initialValues={initValue}
                        validationSchema={Yup.object().shape(validationSchemaForCoisVeiw)}
                        onSubmit={ this.onHandleSubmit }
                    >
                        {({setFieldValue, values, errors, ...rest}) => {
                            return (
                                <Form action="">
                                    <div className="doc-info">
                                        <div className="doc-details">
                                            <span className="page-icon">
                                              <i className="icon-cois"/>
                                            </span>
                                            <div className="main-content mt-6">
                                                <h2 className="page-subtitle">
                                                    COI {this.state.currentIndex + 1} of {coisData.length}
                                                </h2>
                                                <p className="color-primary pb-10">click to edit any of the info below</p>
                                                <ul className="details">
                                                    <li>
                                                        <div className={"select-box mr-1" + (err.building ? ' invalid' : '')}>
                                                            <label htmlFor="" className="label">Building:</label>
                                                            <div className="content">
                                                                {properties &&
                                                                <ReactSelect options={properties}
                                                                             name='property_id'
                                                                             setFieldValue={(name, value) => setFieldValue('property_id', value)}
                                                                             field='property_id'
                                                                             value={values.property_id}/>
                                                                }
                                                                {err.building &&
                                                                <p className="error-text">This field is required *</p>}
                                                            </div>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <div className="text-field primary">
                                                            <label htmlFor="" className="label">Insured:</label>
                                                            <div className="content">

                                                                <Field name='insured' type="text"/>
                                                            </div>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <div className="text-field primary">
                                                            <label htmlFor="" className="label">Certificate Holder:</label>
                                                            <div className="content">
                                                                <Field value={values.certificate_holder} name='certificate_holder'
                                                                       type="text"/>
                                                            </div>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <a className="add">+ Add more certificate holders</a>
                                                    </li>
                                                    <li>
                                                        <div className={"select-box mr-1" + (err.building ? ' invalid' : '')}>
                                                            <label htmlFor="" className="label">Vendor Category:</label>
                                                            <div className="content">
                                                                {vendorCategorys &&
                                                                <ReactSelect options={vendorCategorys}
                                                                             setFieldValue={(name, value) => setFieldValue('vendor_category_id', value)}
                                                                             field='vendor_category_id'
                                                                             name='vendor_category_id'
                                                                             value={values.vendor_category_id}/>}
                                                                {err.building &&
                                                                <p className="error-text">This field is required *</p>}
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                                <CoisViewFileds err={errors}
                                                                values={[values.each_occurence, values.damage_to_rented_premises, values.med_exp,
                                                                    values.personal_adv_injury, values.general_aggregate, values.products_comp]}
                                                                keys={['each_occurence', 'damage_to_rented_premises', 'med_exp',
                                                                    'personal_adv_injury', 'general_aggregate', 'products_comp']}
                                                                filedetName='Commercial general liability'/>
                                                <CoisViewFileds err={errors}
                                                                values={[values.aggregate, values.each_occourrence_umbrella, values.umbexp_date]}
                                                                keys={['aggregate', 'each_occourrence_umbrella', 'umbexp_date']}
                                                                filedetName='Umbrella Liability'/>
                                                <CoisViewFileds err={errors}
                                                                values={[values.bodily_injury_per_person, values.bodily_injury_per_accident,
                                                                    values.property_damage_per_accident, values.exp_date]}
                                                                keys={['bodily_injury_per_person', 'bodily_injury_per_accident',
                                                                    'property_damage_per_accident','exp_date']}
                                                                filedetName='Automobile Liability'/>
                                                <CoisViewFileds err={errors}
                                                                values={[values.each_accident, values.disease_ea_employee,
                                                                    values.disease_policy_limit, values.worexp_date]}
                                                                keys={['each_accident', 'disease_ea_employee',
                                                                    'disease_policy_limit', 'worexp_date']}
                                                                filedetName='Workers Compensation'/>
                                            </div>
                                        </div>
                                        <div className="doc-file">
                                            <SliderCarusel data={values.image_path}/>
                                        </div>
                                    </div>
                                    {/*<div className="text-right mt-10">*/}
                                    {/*<a href="/cois/cois-warning" className="btn filled primary w-lg">process COI</a>*/}
                                    {/*</div>*/}
                                    <div className="buttons text-center">
                                        {/*{this.state.currentIndex !== 1 && <a onClick={() => this.setIndex(false)} className="btn filled dark-grey w-lg mr-4 pointer">previous invoice</a>}*/}
                                        {currentIndex !== 0 &&
                                        <a onClick={(v) => setFieldValue('prev_invoice', true)} className="btn filled primary w-lg mr-4 pointer">previous
                                            invoice</a>}
                                        <button className="btn filled grey w-md mr-3">process all COIs at once</button>
                                        {currentIndex + 1 === coisData.length &&
                                        <button type='submit' disabled={disabled}
                                                className="btn filled primary w-md">process COI</button>}
                                        {currentIndex + 1 !== coisData.length &&
                                        <button type='submit' name="next_invoice" value="true" onClick={(v) => setFieldValue('next_invoice', true)}
                                                className="btn filled primary w-md">next invoice</button>}
                                    </div>
                                </Form>
                            )
                        }}
                    </Formik>
                </div>
            )
    }
}

const mapStateToProps = state => {
    return {
        coisData: state.settings.coisData,
        pending: state.settings.pending,
        properties: state.settings.properties,
        vendorCategorys: state.settings.vendorCategorys,
        coisValues: state.settings.coisValues,
    }
};

export default connect(mapStateToProps,{
    getPropertyManagersAction,
    getVendorCategoryAction,
    addCoisDataAction,
    clearCoisDataStorAction,
    changeCoisValuesArrayAction,
    rewriteCoisValuesArrayAction,
})(CoisView);


// WEBPACK FOOTER //
// ./src/components/Cois/CoisView.tsx